import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { iranHotelsService } from './iran-hotels.service';

export const iranHotelsResolver: ResolveFn<any> = () => {
  const intnhService = inject(iranHotelsService);
  const platformId = inject(PLATFORM_ID);
  if (isPlatformServer(platformId)) {
    /// api/mvc/iranhotels
    return intnhService.getIranHotels(); //  فقط در SSR
  } else {
   intnhService.getIranHotels(); //  در CSR فقط اجرا
    return;
  }
}
  